export default __webpack_public_path__ + "static/media/microsoft.bc0ef567.svg";